import * as React from 'react'

import { TimesheetOvertimeRequestFragment } from 'generated/resources/graphql'

const Context = React.createContext<Array<TimesheetOvertimeRequestFragment>>([])

export const OvertimeRequestsProvider = ({
  collection,
  children,
}: {
  collection: Array<TimesheetOvertimeRequestFragment>
  children: React.ReactNode
}) => <Context.Provider value={collection}>{children}</Context.Provider>

export const useOvertimeRequests = (): Array<TimesheetOvertimeRequestFragment> => {
  const OvertimeRequests = React.useContext(Context)

  if (!OvertimeRequests) {
    throw new Error('useOvertimeRequests must be used within an OvertimeRequestsProvider')
  }

  return OvertimeRequests
}
